module.exports = __webpack_public_path__ + "static/media/clock.93dba0c8.svg";